import { createContext } from "react";

let AuthContext = createContext(); // Correctly creating the context

export default AuthContext; // Correctly exporting it
